import { Stack, Text } from '@mantine/core'
import MainDrawer from 'app/views/components/Drawer/MainDrawer'
import { LendersPosition } from 'app/models/lenders-position-params'
import { CustomLoaderPage } from 'app/views/components/loader/loader-page'
import HistoryAccordion from '../deals-management/lender-allocations/history-accordion'

interface Props {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  /** The row's lender, for the title: the grid row carries the name. */
  title: string
  /** The read of the row's position: in flight, landed, or landed with nothing (no position, or the request failed). */
  state: 'loading' | 'ready' | 'missing'
  /** The position with its pro-rata history, fetched when the drawer opens. */
  lendersPosition?: LendersPosition
}

export default function PositionDrawer({ open, setOpen, title, state, lendersPosition }: Props) {
  return (
    <MainDrawer opened={open} setOpen={setOpen} titleText={title}>
      <Stack w="100%" mt="20px" className="sectionRemoveGap">
        {state === 'ready' && lendersPosition ? (
          <HistoryAccordion lendersPosition={lendersPosition} />
        ) : state === 'loading' ? (
          <CustomLoaderPage />
        ) : (
          <Text data-testid="position-missing">No position history could be loaded for this facility.</Text>
        )}
      </Stack>
    </MainDrawer>
  )
}
